export const scrollToBottom = () => {
  const element = document.querySelector('.messagesArea > div:last-child') || document.documentElement;
  element.scrollIntoView({ behavior: 'smooth' });
};
